import { render } from "./Navigation.vue?vue&type=template&id=8f56bdd6"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=8f56bdd6&lang=scss"
script.render = render

export default script